function scriptLoaded(url) {
  return Array.from(document.scripts).some((script) =>
    script.src.includes(url)
  );
}

function styleLoaded(url) {
  return Array.from(document.querySelectorAll("link")).some(
    (link) => link.href === url
  );
}

function styleCreate(url) {
  if (styleLoaded(url)) {
    return;
  }
  
  const link = document.createElement("link");

  link.rel = "stylesheet";

  link.href = url;

  document.head.appendChild(link);


}

function scriptCreate(url) {
  if (scriptLoaded(url)) {
    return;
  }
  
  const script = document.createElement("script");

  script.src = url;

  document.head.appendChild(script);
}

function initGalleryCarousels(scope = document) {
  const carousels = scope.querySelectorAll('[id^="media-carousel-"], [id^="product-carousel-"]');

  carousels.forEach((carousel) => {
    if (!carousel.classList.contains('slick-initialized') && window.jQuery) {
      const $ = window.jQuery;

      const options = {
        arrows: carousel.dataset.arrows == 'true',
        lazyload: 'ondemand',
        dots: carousel.dataset.dots == 'true',
        infinite: carousel.dataset.infinite == 'true',
        centerMode: false,
        variableWidth: false,
        autoplay: carousel.dataset.autoplay == 'true',
        autoplaySpeed: parseInt(carousel.dataset.autoplaySpeed || '3000', 10),
        slidesToShow: parseInt(carousel.dataset.slidesToShow || '3', 10),
        slidesToScroll: parseInt(carousel.dataset.slidesToScroll || '1', 10),
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: parseInt(carousel.dataset.slidesToShowMobile || '1', 10),
              slidesToScroll: 1
            }
          }
        ]
      };

      const galleryWrapper = carousel.closest('.media-carousel, .product-carousel');
      if (galleryWrapper) {
        galleryWrapper.style.visibility = 'hidden';
      }

      $(carousel).on('init', function () {
        carousel.classList.add('slick-initialized');
        if (galleryWrapper) {
          galleryWrapper.style.visibility = 'visible';
        }
      });

      $(carousel).slick(options);
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initGalleryCarousels();
});

if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function (event) {
    initGalleryCarousels(event.target);
  });
}